export default __webpack_public_path__ + "media/bundles/Sso/src/components/templates/AppTemplate/stars-24cbdc2a82c35dcbed92da02209c055a.svg";